
import React from 'react';

const CtoServiceDetails = () => {
  const serviceDetails = [
    {
      title: "Budget-Planung",
      description: "Jahres- und Quartals­pläne, laufende Kosten­kontrolle, Spar­ideen"
    },
    {
      title: "Projekt-Steuerung",
      description: "Prioritäten, Termine, Risiko­ampel – alles auf einer Seite"
    },
    {
      title: "Anbieter-Prüfung",
      description: "Angebote vergleichen, Verträge verhandeln, Service prüfen"
    },
    {
      title: "Zahlen & Berichte",
      description: "Klare Kennzahlen für Geschäfts­leitung und Steuerberater"
    },
    {
      title: "Veränderungs-Begleitung",
      description: "Schulungen, Info-Mails, damit alle mitziehen"
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">So helfen wir dir – in einfachen Worten</h2>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-4 text-left border-b-2 border-gray-200 text-gray-800">Wir übernehmen ...</th>
                  <th className="p-4 text-left border-b-2 border-gray-200 text-gray-800">Damit bekommst du ...</th>
                </tr>
              </thead>
              <tbody>
                {serviceDetails.map((service, index) => (
                  <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                    <td className="p-4 font-medium text-blue-700">{service.title}</td>
                    <td className="p-4 text-gray-700">{service.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <p className="text-center mt-8 text-gray-700 italic">
            Alles remote, unabhängig und immer im Interesse deines Unternehmens.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CtoServiceDetails;
